import { ACTIONS_ALERT_FAVORITE, CLICK_SECTIONS, CLICKOUT_SUBSECTIONS, SHARE_METHODS } from 'constants/constants';
import { logFavourite, logSharing } from 'services/tracking/logger';
import { trackEstablishmentModalAction, trackFavoriteFromModal, trackShareFromEstablishment } from 'services/tracking';
import { gAEstablishmentModalAction } from 'services/tracking/g-analytics';
import { openClickout } from 'services/clickout';


export function handleClickout(props, partnerId, clickFrom, sectionTrack = CLICK_SECTIONS.ESTABLISHMENT) {
  trackEstablishmentModalAction('clickout', clickFrom);
  return openClickout(partnerId, clickFrom, sectionTrack, props);
}

export function handleFacebookShare(props) {
  trackShareFromEstablishment('facebook');
  logSharing(props.establishment.id, SHARE_METHODS.FACEBOOK);
}

export function handleWhatsappShare(props) {
  trackShareFromEstablishment('whatsapp');
  logSharing(props.establishment.id, SHARE_METHODS.WHATSAPP);
}

export function toggleSaved(origin, props) {
  const { establishment: { id }, isSaved, requestSave, requestUnsave, userIsAuthenticated } = props;

  if (isSaved) {
    requestUnsave(id);
    trackFavoriteFromModal(ACTIONS_ALERT_FAVORITE.REMOVE, origin === 'sticky' ? 'favorite_sticky' : 'favorite_establishment_page');
  } else {
    requestSave(id);
    trackFavoriteFromModal(ACTIONS_ALERT_FAVORITE[userIsAuthenticated ? 'ADD' : 'CLICK_ELEMENT'], origin === 'sticky' ? 'favorite_sticky' : 'favorite_establishment_page');
    logFavourite(id);
  }
}

export function handleGridClick(partners, i) {
  gAEstablishmentModalAction('click image position', i);
  if (partners[0]) partners[0].handleClickout(CLICKOUT_SUBSECTIONS.ESTABLISHMENT_IMAGE).call();
}
